import { LoadingScreenProps } from '../types';

const LoadingScreen = ({ message }: LoadingScreenProps) => (
  <div className="flex flex-col items-center justify-center h-full text-center p-6 space-y-4">
    <div className="w-12 h-12 border-4 border-sky-200 border-t-sky-500 rounded-full animate-spin"></div>
    <p className="text-sky-600 font-bold animate-pulse">{message}</p>
  </div>
);

export default LoadingScreen;